import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  AddEditEmployeeExpensePayloadType,
  SingleEmployeeExpensePayloadType,
} from "../../commonTypes/expenseManagementTypes";
import {
  addEmployeeExpenseApi,
  deleteEmployeeExpenseApi,
  getAllEmployeeExpensesApi,
  getSingleEmployeeExpenseApi,
  updateEmployeeExpenseApi,
} from "../../apis/expenseManagementApis";

export const addEmployeeExpenseAction = createAsyncThunk(
  "expenseManagement/addExpense",
  async (data: AddEditEmployeeExpensePayloadType) => {
    const response = await addEmployeeExpenseApi(data);
    return response.data;
  }
);

export const updateEmployeeExpenseAction = createAsyncThunk(
  "expenseManagement/updateExpense",
  async (data: AddEditEmployeeExpensePayloadType) => {
    const response = await updateEmployeeExpenseApi(data);
    return response.data;
  }
);

export const getAllEmployeeExpnsesAction = createAsyncThunk(
  "expenseManagement/getAllExpenses",
  async (token: string) => {
    const response = await getAllEmployeeExpensesApi(token);
    return response.data;
  }
);

export const getSingleEmployeeExpenseAction = createAsyncThunk(
  "expenseManagement/getSingleEmployeeExpense",
  async (data: SingleEmployeeExpensePayloadType) => {
    const response = await getSingleEmployeeExpenseApi(data);
    return response.data;
  }
);

export const deleteEmployeeExpenseAction = createAsyncThunk(
  "expenseManagement/deleteEmployeeExpense",
  async (data: SingleEmployeeExpensePayloadType) => {
    const response = await deleteEmployeeExpenseApi(data);
    return response.data;
  }
);
